module.exports = __webpack_public_path__ + "img/logo-mini-color.9146cf19.png";